<script lang="ts" setup>
import {
    type IContentElement,
    logInteraction,
} from '@bosca/analytics-client-browser'

export type ButtonType = 'button' | 'image-button' | undefined

const props = defineProps<{
  id: string
  type?: ButtonType
  disabled?: boolean | undefined
  extras?: { [key: string]: string } | undefined
  content?: IContentElement[] | []
  click?: (() => void) | undefined
}>()

async function onClick() {
    await logInteraction({
        id: props.id,
        type: props.type || 'button',
        extras: props.extras || {},
        content: props.content || [],
    })
}
</script>

<template>
  <button
    :disabled="disabled || false"
    @click="
      () => {
        if (click) click()
        onClick()
      }
    "
  >
    <slot />
  </button>
</template>
